import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useRetrievePlayer, useRetrieveUserPlayerPermissions, useUpdatePlayer, } from "../ApiProvider";
import { ErrorView } from "../nav/Error";
import { Forbidden } from "../nav/Forbidden";
import { Loading } from "../nav/Loading";
import ErrorSnackbar from "../utils/ErrorSnackbar";
import { useNumericParams } from "../utils/useNumericParams";
import { PlayerDisplayNameLink } from "./PlayerDisplayNameLink";
import { PlayerForm } from "./PlayerForm";
export const UpdatePlayerForm = () => {
    const { id } = useNumericParams();
    const navigate = useNavigate();
    const { data: userPlayerPermissions, isLoading: userPlayerPermissionsIsLoading, error: userPlayerPermissionsError, } = useRetrieveUserPlayerPermissions({ playerId: id });
    const { canModify = false } = userPlayerPermissions || {};
    const { isLoading: useRetrievePlayerIsLoading, error: useRetrievePlayerError, data: player, } = useRetrievePlayer({ id, enabled: canModify });
    const updatePlayerMutation = useUpdatePlayer({
        id,
        onMutate: () => { },
        onSuccess: (data) => {
            navigate(`/players/${id}/`);
            return data.data;
        },
        onError: () => { },
    });
    if (userPlayerPermissionsError) {
        return _jsx(ErrorView, { error: userPlayerPermissionsError });
    }
    if (userPlayerPermissionsIsLoading) {
        return _jsx(Loading, {});
    }
    if (!canModify) {
        return _jsx(Forbidden, {});
    }
    const loading = useRetrievePlayerIsLoading || updatePlayerMutation.isLoading;
    if (loading) {
        return _jsx(Loading, {});
    }
    if (useRetrievePlayerError) {
        return _jsx(ErrorView, { error: useRetrievePlayerError });
    }
    if (!player) {
        return _jsx(ErrorView, { error: new Error("Could not load player!") });
    }
    return (_jsxs(React.Fragment, { children: [_jsx(ErrorSnackbar, { open: !!updatePlayerMutation.isError, message: "Failed to update player!" }), _jsx(Typography, { variant: "h6", children: _jsxs("strong", { children: ["Update ", _jsx(PlayerDisplayNameLink, { player: player })] }) }), _jsx(PlayerForm, { player: player, onSubmit: updatePlayerMutation.mutate, onCancel: () => {
                    navigate(-1);
                } })] }));
};
